import { PropTypes, Typography } from "@mui/material";
import styles from "./NoData.module.scss";
import { FC } from "react";

interface PropTypes {
    message?: string | (() => string);
}

const NoData: FC<PropTypes> = ({ message }) => {
    return (
        <div className={styles.NoData}>
            <Typography>{message ? typeof message === "string" ? message : message() : "No Data Available"}</Typography>
        </div>
    );
};

export default NoData;
